
//num 為數字 pos為小數後幾位
export function formatFloat(num, pos) {
	var size = Math.pow(10, pos);
	return Math.round(num * size) / size;
}
